import script from "./PayModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PayModal.vue?vue&type=script&setup=true&lang=ts"

import "./PayModal.vue?vue&type=style&index=0&id=e4c4999a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4c4999a"]])

export default __exports__